<template>
    <div>
        <div class="tracker-section tracker-section--inline">
            <h2 class="tracker-name heading2 w-100 mb-3">
                Projects
            </h2>
        </div>

        <table class="main-table" v-if="trackers.length">
            <thead>
            <tr>
                <th class="main-table__mid">Project Name</th>
                <th>Description</th>
                <th class="main-table__auto">Startups</th>
                <th>Last Activity</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="tracker in trackers" :key="tracker.id">
                <td>
                    <h5 class="heading5 text-break d-flex">
                        <router-link :to="'/projects/' + tracker.id">{{ tracker.name }}</router-link>
                    </h5>
                </td>
                <td>
                    <div class="main-table__description line-clamp line-clamp4" v-html="tracker.description"></div>
                </td>
                <td>{{ tracker.startups_count }}</td>
                <td>
                    {{tracker.last_added}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import trackers from "@/services/ecosystem/trackers.service"

export default {
    data() {
        return {
            trackers: [],
        }
    },

    mounted() {
        this.getTrackersList()
    },

    methods: {
        getTrackersList() {
            trackers.getTrackersIndex().then(response => {
                this.trackers = response.data
            })
        },
    }
}
</script>

<style scoped>

</style>